'use client';

import dynamic from 'next/dynamic';

type Props = { sunrise: number; sunset: number };

const SunAnimation = dynamic<Props>(() => import('../SunAnimation'), { ssr: false });

export default function SunAnimationClient(props: Props) {
  return <SunAnimation {...props} />;
}
